export enum StreetSegmentStatusKind {
    SURFACE = 'SURFACE',
    MARKINGS = 'MARKINGS',
}